import React from "react";
import PokemonDetails from "../components/individual/PokemonDetails";

const IndividualPage = () => {
  return (
    <div className="page">
      <PokemonDetails />
    </div>
  );
};

export default IndividualPage;
